import React, { forwardRef, useState } from "react";
import './ContactSection.css';
import MapStatic from "../../components/MapStatic";
import Footer from "../../components/Footer";
const ContactSection= forwardRef((props, ref) =>  {
  const [location,setLocation]=useState({lat:-23.529888,lng:-46.708498})
  const handlerLocation = (lat,lng) => {
    setLocation({lat:lat,lng:lng});
  }

  const handlerCopy = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        alert('Copiado!');
    } catch (err) {
    }

}
  return (
    <section id={"contact-section"} className="contact-section" ref={ref}> 
      <div className="info">
        <div className="list-wrapper">
          <h2>CONTATO E LOCALIZAÇÃO</h2>
          <div className="list">
            <div className="contact-wrapper">
              <i className="fa-regular fa-envelope"></i>
              <div>
                <label>Email</label>
                <p>zupaestudio@gmail.com</p>
              </div>
            </div>
            <div className="contact-wrapper">
              <a href={'https://wa.me/5511950742962'} target={"_blank"}><i className="fa-brands fa-whatsapp"></i></a>
              <div>
                <label>Whatsapp</label>
                <p>55 11 95074 2962</p>
              </div>
            </div>
            <div className="contact-wrapper">
              <a target={"_blank"} href={'https://maps.app.goo.gl/nRqjAwYJQkxqKVCo7?g_st=com.google.maps.preview.copy'}><i className="fa fa-location-dot"></i></a>
              <div>
                <label>Rua Ponta Porã 447</label>
                <p>Lapa - São Paulo / SP</p>
                </div>
            </div>
          </div>
          <div className="divider"></div>
          <p id="places-text">A menos de <span>5 minutos</span> de mercados, restaurantes, padarias, farmácias e lojas de utilidades:</p>
          <div className="places">
            <div className="row">
              <button onClick={()=>handlerLocation(-23.5283305,-46.7024218)}><img src="/assets/icons/md.png"/></button>
              <button onClick={()=>handlerLocation(-23.5283305,-46.7024218)}><img src="/assets/icons/ph.png"/></button>
              <button onClick={()=>handlerLocation(-23.5358087,-46.7097713)}><img src="/assets/icons/bk.png"/></button>
              <button onClick={()=>handlerLocation(-23.540731,-46.698995)}><img src="/assets/icons/hb.png"/></button>
            </div>
            <div className="row">
              <button onClick={()=>handlerLocation(-23.5351011,-46.7137295)}><img src="/assets/icons/bg.png"/></button>
              <button onClick={()=>handlerLocation(-23.5344173,-46.7120191)}><img src="/assets/icons/pa.png"/></button>
              <button onClick={()=>handlerLocation(-23.5281504,-46.7042827)}><img src="/assets/icons/dr.png"/></button>
              <button onClick={()=>handlerLocation(-23.5284102,-46.701624)}><img src="/assets/icons/ds.png"/></button>
            </div>
          </div>
        </div>
        <MapStatic position={location}/>  
      </div>
      
      <Footer />
    </section>
  );
});

export default ContactSection;
